import {checkExhaustive} from 'external/dev_april_corgi+/js/common/asserts';
import * as corgi from 'external/dev_april_corgi+/js/corgi';
import {
  Button as EmuButton,
  ButtonProps,
} from 'external/dev_april_corgi+/js/emu/button';
import {
  Checkbox as EmuCheckbox,
  CheckboxProps,
} from 'external/dev_april_corgi+/js/emu/checkbox';
import {
  Input as EmuInput,
  InputProps,
} from 'external/dev_april_corgi+/js/emu/input';
import {Select as EmuSelect} from 'external/dev_april_corgi+/js/emu/select';

export function Button({
  buttonType,
  className,
  ...props
}: ButtonProps & {
  buttonType?: 'primary' | 'secondary' | 'dangerous';
}) {
  buttonType ??= 'primary';
  let colors;
  if (buttonType === 'primary') {
    colors = {
      active: 'active:bg-emerald-700',
      default: 'bg-emerald-600',
      hover: 'hover:bg-emerald-600/90',
    };
  } else if (buttonType === 'secondary') {
    colors = {
      active: 'active:bg-neutral-700',
      default: 'bg-neutral-600',
      hover: 'hover:bg-neutral-600/90',
    };
  } else if (buttonType === 'dangerous') {
    colors = {
      active: 'active:bg-red-700',
      default: 'bg-red-600',
      hover: 'hover:bg-red-600/90',
    };
  } else {
    throw checkExhaustive(buttonType);
  }
  return (
    <EmuButton
      className={
        `${colors.default} ${colors.active} ${colors.hover} px-2 rounded hover:cursor-pointer` +
        (className ? ' ' + className : '')
      }
      {...props}
    />
  );
}

export function Checkbox({className, ...props}: CheckboxProps) {
  return (
    <EmuCheckbox
      className={'accent-emerald-600' + (className ? ' ' + className : '')}
      {...props}
    />
  );
}

export function OutlinedButton({className, ...props}: ButtonProps) {
  return (
    <EmuButton
      className={
        'border border-emerald-600 px-2 rounded active:bg-emerald-800 ' +
        'hover:bg-emerald-700/90 hover:cursor-pointer' +
        (className ? ' ' + className : '')
      }
      {...props}
    />
  );
}

export function Input({className, ...props}: InputProps) {
  return (
    <EmuInput
      className={'border border-neutral-50 p-1 rounded ' + className}
      {...props}
    />
  );
}

export function Select({className, ...props}: Parameters<typeof EmuSelect>[0]) {
  return (
    <EmuSelect
      className={'border border-neutral-50 p-1 rounded ' + className}
      {...props}
    />
  );
}
